import {
  SwApi,
  LanguageString,
  PlatformString,
  SwApiOptions,
} from "@sworkit/api";
import { getEnvFromState, isOnBetaWebApp } from "./utils";
import data from "../../package.json";
import { initPolyglot } from "./translate";
import { getDeviceLanguage } from "./sw-device";
import { initLogRocket } from "./log-rocket";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { getRootURL } from "./oauth-consts";

export const jsVersion: string = (data as any).version;
export const buildNumber: string = (data as any).buildNumber;
export const jsVersionWithBuildNumber = `${jsVersion} (${buildNumber})`;

const platform = Capacitor.getPlatform() as PlatformString;

export let swApi: SwApi;

export async function initSwApi(
  state: SworkitPersistedState,
  ignoreFirebase = false,
) {
  console.log("ignore firebase?", ignoreFirebase);

  window["fns"] = await import("date-fns");
  let env = getEnvFromState(state);
  if (isOnBetaWebApp() && env === "prod") {
    env = "beta";
  }
  if (getRootURL()?.includes("localhost:5555")) {
    env = "alpha";
  }
  const verifiedLanguageString = await getLocale(state);
  updateLanguage(verifiedLanguageString);
  console.debug("init swApi", verifiedLanguageString);
  initLogRocket(env, jsVersionWithBuildNumber);
  return new Promise<void>((resolve) => {
    const options: SwApiOptions = {
      publicKey: "8c93c4cdbf23fe4074626e51c7a2b1db",
      platform,
      env,
      ignoreFirebase,
      language: verifiedLanguageString,
      onReady: async () => {
        resolve();
      },
      onDataRefresh: async () => {
        await initPolyglot();
        const evt = new CustomEvent("swApiDataRefresh");
        window.dispatchEvent(evt);
      },
    };
    swApi = new SwApi(options);
    window["swApi"] = swApi;
    swApi.initAnalytics();
  });
}

// Function to update the language and direction
export function updateLanguage(langCode) {
  const htmlElement = document.documentElement;

  // Set the language code
  htmlElement.lang = langCode;
}

// @TODO: remove getAll function if not needed
export async function getAll(state: SworkitPersistedState) {
  window["fns"] = await import("date-fns");
  let env = getEnvFromState(state);
  if (isOnBetaWebApp() && env === "prod") {
    env = "beta";
  }
  const verifiedLanguageString = await getLocale(state);
  console.debug("init swApi", verifiedLanguageString);
  initLogRocket(env, jsVersionWithBuildNumber);
  return new Promise<void>((resolve) => {
    const options: SwApiOptions = {
      publicKey: "8c93c4cdbf23fe4074626e51c7a2b1db",
      platform,
      env,
      language: verifiedLanguageString,
      onReady: async () => {
        await initPolyglot();
        resolve();
      },
      onDataRefresh: () => {
        const evt = new CustomEvent("swApiDataRefresh");
        window.dispatchEvent(evt);
      },
    };
    swApi = new SwApi(options);
    window["swApi"] = swApi;
    swApi.initAnalytics();
  });
}

export function openInNewWindow(url: string) {
  return Browser.open({ url });
}

async function getLocale(state: SworkitPersistedState) {
  if (state && state.user && state.user.account && state.user.account.locale) {
    const localePref = state.user.account.locale;
    return getVerifiedLanguageString(localePref);
  } else {
    const deviceLocale = await getDeviceLanguage();
    return getVerifiedLanguageString(deviceLocale);
  }
}

function getVerifiedLanguageString(language: LanguageString) {
  const validLanguageString: LanguageString[] = [
    "en",
    "de",
    "es",
    "esla",
    "fr",
    "hi",
    "it",
    "ja",
    "ko",
    "pt",
    "ru",
    "tr",
    "zh",
    "hu",
    "th",
  ];
  const isValid = validLanguageString.indexOf(language) !== -1;
  if (isValid) {
    return language;
  } else {
    return "en";
  }
}

export function isMemberWorkout(slug: string) {
  return slug && slug.includes("-9-");
}
